import React from 'react';

import useScholarshipData from './useScholarshipData';
import Choice from './choice';
import RenderIf from '../../renderIf';
import Acceptance from './acceptance';
import Declination from './declination';
import { Dialog, DialogTitle } from '@mui/material';

const AcceptDecline = (props) => {
    const { AppInstID, Status, StudentName, SchoolName, handleClose } = props;

    const [step, setStep] = React.useState(1);
    const { scholarshipData, retrieveScholarshipData, acceptScholarship, declineScholarship } = useScholarshipData(
        AppInstID,
        Status,
        handleClose
    );

    React.useEffect(() => {
        retrieveScholarshipData();
    }, []);

    return (
        <Dialog open={true}>
            <RenderIf isTrue={scholarshipData?.Loading === undefined || scholarshipData?.Loading === true}>
                <DialogTitle>Retrieving scholarship data...</DialogTitle>
            </RenderIf>

            <RenderIf isTrue={scholarshipData?.Loading === false && step === 1}>
                <Choice
                    schoolName={SchoolName}
                    status={Status}
                    scholarshipData={scholarshipData}
                    handleStepChange={setStep}
                    handleClose={handleClose}
                />
            </RenderIf>

            <RenderIf isTrue={scholarshipData?.Loading === false && step === true}>
                <Acceptance
                    studentName={StudentName}
                    term={scholarshipData.Term}
                    handleBack={() => setStep(1)}
                    handleConfirm={acceptScholarship}
                />
            </RenderIf>

            <RenderIf isTrue={scholarshipData?.Loading === false && step === false}>
                <Declination
                    handleBack={() => setStep(1)}
                    handleConfirm={declineScholarship}
                />
            </RenderIf>
        </Dialog>
    );
};

export default AcceptDecline;
